import script from "./GlobalSupportFab.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSupportFab.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalSupportFab.vue?vue&type=style&index=0&id=c3ceb81a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3ceb81a"]])

export default __exports__